import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SipCardOnPaymentComponent } from './sip-card-on-payment/sip-card-on-payment.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HowItWorksModule } from '../how-it-works/how-it-works.module';

@NgModule({
  declarations: [SipCardOnPaymentComponent],
  exports: [SipCardOnPaymentComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatSlideToggleModule,
    HowItWorksModule
  ]
})
export class SipCardOnPaymentModule { }
